export default __webpack_public_path__ + "static/media/home-hgtag-academy.80d40f80.jpg";